var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCalendarStencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.895h22.895V0H0v22.895zM.939 5.117h21.018V.94H.939v4.178zm0 16.84h21.018V6.056H.939v15.9z",
    transform: "translate(-779 -307) translate(779 307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.258 3.168L8.365 3.168 8.365 2.229 6.258 2.229zM14.531 3.168L16.638 3.168 16.638 2.229 14.531 2.229zM2.737 12.616H6.67V8.25H2.737v4.365zm-.94.94H7.61V7.311H1.798v6.243zM9.48 12.616h3.934V8.25H9.481v4.365zm-.938.94h5.81V7.311h-5.81v6.243zM16.225 12.616h3.934V8.25h-3.934v4.365zm-.938.94h5.81V7.311h-5.81v6.243zM2.737 19.798H6.67v-4.365H2.737v4.365zm-.94.939H7.61v-6.243H1.798v6.243zM9.48 19.798h3.934v-4.365H9.481v4.365zm-.938.939h5.81v-6.243h-5.81v6.243zM16.225 19.798h3.934v-4.365h-3.934v4.365zm-.938.939h5.81v-6.243h-5.81v6.243z",
    transform: "translate(-779 -307) translate(779 307)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarStencil);
export default __webpack_public_path__ + "static/media/ic-calendar-stencil.181b263c1a45b724c5aa6f698ac29c1b.svg";
export { ForwardRef as ReactComponent };